import React from 'react'
import { Link } from 'react-router-dom'
import Step1 from '@loyal_images/landings/cashBack/step-1.png'
import Step2 from '@loyal_images/landings/cashBack/step-2.png'

const StepsExplanation = () => {
  const linkRegulamento = 'https://atendimentoiupp.zendesk.com/hc/pt-br/articles/360059719931-Regulamento-Cashback-com-cr%C3%A9dito-em-fatura-no-iupp'
  return (
    <div className='step-explanation'>
      <div className='container'>
        <div className='content-box'>
          <div className='box boxPrime'>
            <h3>Passo 1</h3>
            <p className='oneProduct'>Primeiro você escolhe um produto no shopping iupp</p>
            <p className='titleProduct' aria-hidden='true'>
              Aqui no exemplo a cadeira gamer custa <strong className='brand4'>R$ 1.000,00</strong>. Pagando com cartão de crédito Itaucard ou Personnalité, você ganhará <strong className='success'> 3.000 pts</strong> em até 40 dias.
            </p>
            <p className='titleProduct mt-2'>
              Aguarde a confirmação da chegada dos pontos iupp em sua conta.
            </p>
            <span className='hide-absolute'>Aqui no exemplo a cadeira gamer custa R$ 1.000,00. Pagando com cartão de crédito Itaucard ou Personnalité, você ganhará 3.000 pts em até 40 dias.</span>
          </div>
          <div className='box boxTwo d-flex justify-content-center'>
            <img aria-hidden='true' className='imgStep1' src={Step1} title='Primeiro você escolhe um produto no shopping iupp' />
          </div>
        </div>
        <div className='content-box'>
          <div className='box orderFix boxPrime'>
            <img aria-hidden='true' className='imgStep2' src={Step2} title='Troque seus pontos por crédito em fatura.' />
          </div>
          <div className='box boxTwo'>
            <h3 className='m-top'>Passo 2</h3>
            <p aria-hidden='true' className='oneProduct'>Troque seus pontos por <br /> crédito em fatura.</p>
            <span className='hide-absolute'>Troque seus pontos por crédito em fatura.</span>
            <p aria-hidden='true' className='titleProduct'>
              Você poderá <strong className='brand4'>trocar esses 3.000 pts</strong> por <strong className='success'>R$ 60,00 </strong> que entrarão como crédito na sua próxima fatura:
            </p>
            <span className='hide-absolute'>Você poderá trocar esses 3.000 pts por R$ 60,00 que entrarão como crédito na sua próxima fatura:</span>
            <p className='cashback-text'>
              Totalizando um Cashback 6%.
            </p>
            <Link role='button' className='btn-credit' to='/invoice-credit'>
              <strong>Quero crédito em fatura</strong>
            </Link>
            <a
              className='link-regulation'
              target='_blank'
              href={linkRegulamento}>
              Veja o regulamento
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepsExplanation



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashbackBlack/StepsExplanation/StepsExplanation.js